import cn from 'classnames';
import { useContext } from 'react';

import Text from 'components/common/Text';
import Logo from 'components/signUpFunnel/Logo';
import { BrandContext, TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import styles from 'styles/components/signUpFunnel/ProgressBar';

import BackButton from './BackButton';
import { ProgressBarContext } from './Contexts';

const ProgressBar = () => {
  const { progress } = useContext(ProgressBarContext);
  const { brand } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);

  const steps = [
    { name: 'intro', locationPercentage: '16' },
    { name: 'preferences', locationPercentage: '28' },
    { name: 'box size', locationPercentage: ['44', '47', '51', '58'] },
    { name: 'checkout', locationPercentage: '67' },
    { name: 'pick meals', locationPercentage: '76' },
  ];

  const StepIndicator = () => {
    return (
      <div className="flex space-x-10 px-10 pb-2 bp3:space-x-20 bp3:px-12">
        {steps.map(step => {
          const stepInProgressOrCompleted =
            parseInt(progress.percent) >= parseInt(step.locationPercentage);
          return (
            <Text
              key={step.name}
              brandStylesOverrides="h7"
              className={cn('flex-none text-xs font-medium uppercase', {
                [styles[brand]]: stepInProgressOrCompleted,
                'text-charcoal-100': !stepInProgressOrCompleted,
              })}
            >
              {step.name}
            </Text>
          );
        })}
      </div>
    );
  };

  const CompletedBar = () => {
    const mobileProgress = progress.mobile || progress.percent;

    return (
      <div className="relative h-1.5 rounded bg-charcoal-60">
        <div
          className={cn(
            'pointer-events-none absolute left-0 top-0 block h-full rounded bp1:hidden',
            styles.progressBarForeground,
            styles[brand]
          )}
          style={{ width: `${mobileProgress}%` }}
        />
        <div
          className={cn(
            'pointer-events-none absolute left-0 top-0 hidden h-full rounded bp1:block',
            styles.progressBarForeground,
            styles[brand]
          )}
          style={{ width: `${progress.percent}%` }}
        />
      </div>
    );
  };

  return (
    <div className={cn(styles.header, 'z-10 hidden justify-between py-5 shadow bp1:flex')}>
      <BackButton />
      <div className={cn(styles.progressBarWrapper, 'flex-initial py-1.5')}>
        <StepIndicator />
        <CompletedBar />
      </div>
      <div className={cn('flex-initial', { 'pt-2.5': isTempo })}>
        <Logo />
      </div>
    </div>
  );
};

export default ProgressBar;
